import { Callout } from '@radix-ui/themes'
import * as React from 'react'
import { RxCircleBackslash } from 'react-icons/rx'
import { type FetcherError } from '#app/models/ecommerce-providers/sylius/fetcher.ts'

type ErrorMessageProps = FetcherError & {
	defaultMessage: string
	calloutProps?: Callout.RootProps
}

const ErrorMessage: React.FC<ErrorMessageProps> = ({
	calloutProps,
	...rest
}) => {
	console.error('ErrorMessageComponent', rest)

	return (
		<Callout.Root color="red" {...calloutProps}>
			<Callout.Icon>
				<RxCircleBackslash />
			</Callout.Icon>
			<Callout.Text>{rest.defaultMessage}</Callout.Text>
		</Callout.Root>
	)
}

export { ErrorMessage, type ErrorMessageProps }
